import React from "react";
import "./Profile.scss";

const Profile = () => {
  return <div>Profile</div>;
};

export default Profile;
